import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import ShoppingCartStore from '../../stores/ShoppingCartStore';
import Helmet from 'react-helmet';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Store from '../../models/Store';
import styles from './index.sass';

class StoreLayout extends React.Component {
  static propTypes = {
    currentRoute: React.PropTypes.object,
    isNavigateComplete: React.PropTypes.bool,
    handler: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
    options: React.PropTypes.object
  };

  static defaultProps = {
    options: {
      hideDownloadBanner: false,
      hidePromoBanner: false,
      hideNavbar: false,
      hideFooter: false
    }
  };

  static contextTypes = {
    getExperimentSetting: React.PropTypes.func,
    setExperimentSetting: React.PropTypes.func,
    getUserAgent: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    getCurrentStore: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    let useragent = props.context.getUserAgent();

    this.state = {
      downloadBannerOpen: !props.options.hideDownloadBanner && (useragent.isiOs || useragent.isAndroid) && !props.context.getExperimentSetting('download_banner_dismissed')
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store) {
    let description = store.metaTagDescription();
    let title = store.metaTagTitle();
    let backgroundPhoto = store.background_photo_hash.getClosestToTarget(640);

    return {
      title: title,
      defaultTitle: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:image', content: backgroundPhoto},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:title', content: title},
        {name: 'twitter:image', content: backgroundPhoto},
        {name: 'twitter:description', content: description},
      ]
    };
  }

  handleOnDismissDownloadBanner() {
    this.context.setExperimentSetting('download_banner_dismissed', true);
    this.setState({downloadBannerOpen: false});
    this.context.trackEvent('dismiss_download_banner');
  }

  renderJSONLD(store) {
    let jsonLD = {
      "@context": "http://schema.org",
      "@type": "WebSite",
      "name": store.name,
      "url": store.slug.url
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLD)}} />;
  }

  render() {
    let Handler = this.props.handler;
    // Note: All components have access to store via context.getCurrentStore() now. Passing via props
    // to satisfy current component expectations. There's no reason why we couldn't update all
    // components to check this.context.getCurrentStore() over this.props.store.
    let store = this.context.getCurrentStore();
    let { customer, shoppingCart, currentRoute, isNavigateComplete, options } = this.props;
    let handlerProps = {
      currentRoute,
      isNavigateComplete,
      customer,
      shoppingCart,
      store
    };
    let navbarProps = {
      currentRoute,
      customer,
      shoppingCart,
      store
    };
    let footerProps = {
      store
    };
    let className = styles.storeLayout;
    // let downloadBanner;

    let promoBanner;
    // Override with store banner
    if (store.banner) {
      promoBanner = (
        <div className={styles.promoBanner}>
          <span>{store.banner}</span>
        </div>
      );
      className += ` promobanner--open`;
    } else if(shoppingCart && shoppingCart.marketing_message && !options.hidePromoBanner) {
      promoBanner = (
        <div className={styles.promoBanner}>
          <span>{shoppingCart.marketing_message.text}</span>
        </div>
      );
      className += ` promobanner--open`; // global classname so sub-components can react accordingly
    }

    return (
      <div className={className}>
        <Helmet {...this.getHelmetProps(store)} />
        {this.renderJSONLD(store)}
        {promoBanner}
        {options.hideNavbar ? null : <Navbar {...navbarProps} />}
        <Handler {...handlerProps} />
        {options.hideFooter ? null : <Footer {...footerProps} />}
      </div>
    );
  }
}

StoreLayout = connectToStores(StoreLayout, [CustomerStore, ShoppingCartStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    shoppingCart: context.getCurrentStore() ? context.getStore(ShoppingCartStore).getShoppingCartByStoreId(context.getCurrentStore().id) : null
  };
}, {
  getCurrentStore: React.PropTypes.func
});

export default StoreLayout;



// WEBPACK FOOTER //
// banquet/layouts/StoreLayout/index.js